import { MenuItem } from "./MenuItem";
import { routesData } from "../app/routesData";
import "./style.css";

export const ExtendMenu = ({ handleToggle }) => {
    return (
      <div className={`site__navigation menu__opend`}>
        <div className="bg__menu h-100">
          <div className="menu__container p-3">
            <ul className="the_menu">
              {
                routesData.map((data, i) => {
                  return (
                    <li key={i} className="menu_item">
                      <MenuItem path={data.path} desc={data.desc} handleToggle={handleToggle} />
                    </li>
                  );
                })
              }
            </ul>
          </div>
        </div>
      </div>
    );
  };